import { createContext, useCallback, useContext, useMemo, useState } from "react";

const Ctx = createContext(null);
export const TOKEN_KEY = "cvz_token";

export function LocalAuthProvider({ children }) {
  const [token, setTok] = useState(() => localStorage.getItem(TOKEN_KEY));
  const login = useCallback((t) => {
    localStorage.setItem(TOKEN_KEY, t);
    setTok(t);
  }, []);
  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setTok(null);
  }, []);
  const value = useMemo(() => ({ token, login, logout }), [token, login, logout]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useLocalAuth = () => useContext(Ctx);
